module.exports = {"lang":"English"}


//////////////////
// WEBPACK FOOTER
// ./src/widgets/i18n/en.json
// module id = oaki
// module chunks = 85